"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVirtualKeyboard = void 0;
const react_1 = require("react");
const react_use_1 = require("react-use");
const helpers_1 = require("../../lib/helpers");
function useVirtualKeyboard(enabled) {
    const [virtualKeyboardMode, setVirtualKeyboardMode] = react_1.useState(false);
    const isMounted = react_use_1.useMountedState();
    /* Since this is used in a popover and a popover doesnt open (enabled becomes true) until you already
    * have focused an input, so when we become enabled we need to check if we are currently already focused.
    */
    react_1.useEffect(() => {
        if (helpers_1.isServer() || !helpers_1.isOnMobileDevice() || !enabled) {
            return;
        }
        setVirtualKeyboardMode(document.activeElement instanceof HTMLInputElement);
    }, [enabled]);
    react_1.useEffect(() => {
        if (!helpers_1.isOnMobileDevice() || !enabled) {
            return;
        }
        const focusInHandle = (e) => {
            if (!(e.target instanceof HTMLInputElement)) {
                return;
            }
            // buttons can be focused on which doesnt make sense for keyboard.
            setVirtualKeyboardMode(true);
        };
        const focusOutHandle = (e) => {
            if (!(e.target instanceof HTMLInputElement)) {
                return;
            }
            // must be on next frame, otherwise onClick calls on buttons may not be called from safari
            // which is probably some sort of protection where if the button moves it cancels the click
            // which this state change will readjust the popover buttons
            setTimeout(() => {
                setVirtualKeyboardMode(false);
            }, 0);
        };
        document.addEventListener('focusin', focusInHandle);
        document.addEventListener('focusout', focusOutHandle);
        return () => {
            document.removeEventListener('focusin', focusInHandle);
            document.removeEventListener('focusout', focusOutHandle);
        };
    }, [enabled, isMounted]);
    return virtualKeyboardMode;
}
exports.useVirtualKeyboard = useVirtualKeyboard;
